import axios from "axios";
import {urlConfig} from "../config";
const axiosInstance = axios.create({baseURL: `${urlConfig.momentsServiceUrl}`,auth:{username:sessionStorage.userEmail,password:''}});

export default class MomentService {

    static getMomentClipsForCID(cid) {
        return axiosInstance.get(`/clips/${cid}/momentClips`);
    }

    static getMomentClip(id) {
        return axiosInstance.get(`/momentClips/${id}`);
    }

    static getAllMomentClips() {
        return axiosInstance.get(`/momentClips?search=`);
    }

    static searchMomentClips(title,tags) {
        return axiosInstance.get(`/momentClips?search=title:${title}|tags:${tags}`);
    }

    static saveMomentClips(cid, momentClip) {
        return axiosInstance.post(`momentClips`, momentClip);
    }

    static deleteMomentClip(momentClipId) {
        return axiosInstance.delete(`momentClips/${momentClipId}`);
    }

    static getMomentsPlaylists() {
        return axiosInstance.get('/moments');
    }

    static getMomentsPlaylist(momentsPlaylistId) {
        return axiosInstance.get(`/moments/${momentsPlaylistId}`);
    }

    static saveMomentsPlaylist(momentsPlaylist) {
        return axiosInstance.post(`moments`, momentsPlaylist);
    }

    static deleteMomentsPlaylist(momentsPlaylistId) {
        return axiosInstance.delete(`moments/${momentsPlaylistId}`);
    }

    static removeMomentClipFromPlaylist(momentClipRecord) {
        return axiosInstance.delete(`moments`, {data: momentClipRecord});
    }

    static createMomentsPlaylist(momentsPlaylist) {
        return axiosInstance.put(`moments`, momentsPlaylist);
    }

    static getMomentsCollection(regionId, subregionId, productId) {
        return axiosInstance.get(`/momentsCollections?regionId=${regionId}&subregionId=${subregionId}&productId=${productId}`);
    }

    static saveMomentsCollection(momentsCollection) {
        return axiosInstance.post(`momentsCollections`, momentsCollection);
    }

    static removeMomentsPlaylistFromCollection(momentsCollectionRecord) {
        return axiosInstance.delete(`momentsCollections/`, {data: momentsCollectionRecord});
    }

    static saveMomentsCollectionOrder(momentsCollections) {
        return axiosInstance.post(`momentsCollections/reorder`, momentsCollections);
    }

    static createMomentsCollection(momentsCollection) {
        return axiosInstance.put(`momentsCollections`, momentsCollection);
    }

    static deleteCollection(momentsCollectionId) {
        return axiosInstance.delete(`momentsCollections/${momentsCollectionId}`);
    }

    static getMomentClipsCount(){
        return axiosInstance.get(`momentClips/gamificationStatistics/`);
    }

    static getMomentsCount(){
        return axiosInstance.get(`moments/gamificationStatistics/`);
    }
}